import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey:            process.env.GATSBY_FIREBASE_API_KEY,
  authDomain:        process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.GATSBY_FIREBASE_APP_ID,
};

let app, db, auth, storage;

if (typeof window !== 'undefined') {
  app  = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
  db   = getFirestore(app);
  auth = getAuth(app);
  storage = getStorage(app);

  // Login persistente tramite localStorage (sopravvive alla chiusura del browser)
  setPersistence(auth, browserLocalPersistence).catch(() => {});
}

export { db, auth, storage };
export default app;
